import { SpeedDialDesignTokens } from '@primeuix/themes/types/speeddial';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/speeddial/index.ts
const sd = componentCommon.speeddial;

export const SpeeddialTelekomDT: SpeedDialDesignTokens = {
  root: {
    gap: t(sd.gap),
  },
};
